export default class NursePublicProfile {
  id!: number
  full_name!: string
  gdc_number!: string
}
